export default "__VITE_ASSET__CLs35on1__"